import { render, staticRenderFns } from "./currentSwiper.vue?vue&type=template&id=167b28b5&scoped=true&"
import script from "./currentSwiper.vue?vue&type=script&lang=js&"
export * from "./currentSwiper.vue?vue&type=script&lang=js&"
import style0 from "./currentSwiper.vue?vue&type=style&index=0&id=167b28b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b28b5",
  null
  
)

export default component.exports